import { isBlank } from '@faro/design-system';

export interface NameableUser {
    firstName?: string;
    lastName?: string;
    email: string;
}

export function createUserDisplayName(user: NameableUser | undefined): string {
    if (user === undefined) {
        return '';
    }
    return !isBlank(user.firstName)
        ? !isBlank(user.lastName)
            ? `${user.firstName!.trim()} ${user.lastName!.trim()}`
            : user.firstName!.trim()
        : user.email;
}
